export default "__VITE_ASSET__D3PXn2M4__"